import { Component, OnInit } from '@angular/core';
import { PerfilService } from 'src/app/service/perfil.service';
import { LoginService } from 'src/app/service/login.service';
import { ThrowStmt } from '@angular/compiler';

@Component({
  selector: 'app-perfil',
  templateUrl: './perfil.component.html'
})
export class PerfilComponent implements OnInit {
  edit = false;
  editDni: string;
  email: any;
  direccion: string;
  telefono: string;
  msjModal: any;
  dni: any;
  sesion: any
  sexo: any
  user: any = {
    nombres: ''
  };
  loading: boolean = true
  btnEditar: boolean = false;
  btnGuardar: boolean = false;
  despliegaModal: boolean = false;
  constructor(private perfil: PerfilService, private login: LoginService) {
    this.sesion = JSON.parse(localStorage.getItem('sesionPocae'));
    this.user.nombres = localStorage.getItem('nombre');
  }

  ngOnInit() {
    this.btnEditar = true;
    this.loadPerfil();
  }

  loadPerfil() {
  const sIdSesion = this.sesion.ksi || this.sesion.sIdSesion || this.sesion.idSession || '';
  const nIdUsuarioWebSesion = this.sesion.idUsuario || this.sesion.nIdUsuarioWeb || 0;
  const nIdEmpresa = this.sesion.idEmpresa || this.sesion.nIdEmpresa || 1;
  const sHost = this.sesion.host || window.location.hostname || '127.0.0.1';

  const body = {
    sesion: {
      sIdSesion: sIdSesion,
      nIdUsuarioWeb: nIdUsuarioWebSesion,
      nIdEmpresa: nIdEmpresa,
      sHost: sHost
    },
    nIdUsuarioWeb: nIdUsuarioWebSesion
  };

  this.loading = true;

  this.perfil.loadUser(body).subscribe({
    next: (resp: any) => {
      const data = resp?.usuario ?? resp;
      this.user = data;
      localStorage.setItem('nombre', this.user?.nombres ?? '');
      this.email = this.user?.sCorreo ?? '';
      this.direccion = this.user?.sDireccion ?? '';
      this.telefono = this.user?.sTelefono ?? '';
      this.sexo = (this.user?.sexo === 'F') ? 'Femenino' : 'Masculino';
      this.loading = false;
    },
    error: (err) => {
      if (err?.status) {
      }
      this.loading = false;
    }
  });
}



  comproboEmail() {

    let mailValido = false;
    var EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (this.email.match(EMAIL_REGEX)) {
      mailValido = true;
    }

    return mailValido;
  }

  editar() {
    this.btnEditar = false;
    this.btnGuardar = true;
  }

  guardarDatos() {
    this.loading = true;
    if (this.email !== "") {
      if (this.comproboEmail()) {
        let json = {
          sesion: {
            sIdSesion: localStorage.getItem("KSI"),
            nIdUsuarioWeb: this.sesion.idUsuario,
            nIdEmpresa: 5,
            sHost: "127.0.0.1"
          },
          usuario: {
            nIdUsuarioWeb: this.sesion.idUsuario,
            sCorreo: this.email,
            sDireccion: this.direccion,
            sTelefono: this.telefono
          }
        }
        this.perfil.updateUser(json).subscribe(res => {
          if (res) {
            const { numeroError, mensajeError } = res?.estado
            if (numeroError != 0) {
              if (numeroError === 2000) {
                this.loadPerfil();
                this.despliegaModal = true;
                this.loading = false;
                this.msjModal = "Error al actualizar los datos.";
              }
              else {
                this.loadPerfil();
                this.despliegaModal = true;
                this.loading = false;
                this.msjModal = mensajeError;
                this.edit = false
              }
            } else {
              this.despliegaModal = true;
              this.loading = false;
              this.msjModal = "Usuario actualizada correctamente";
              this.edit = false
            }
          } else {
            this.despliegaModal = true;
            this.loading = false;
            this.msjModal = "Error al actualizar los datos. Intente más tarde.";
          }
        }, () => {
          this.despliegaModal = true;
          this.loading = false;
          this.msjModal = "Error al conectar con el servicio. Intente más tarde.";
        })

        this.btnGuardar = false;
        this.btnEditar = true;
      }
      else {
        this.loadPerfil();
        this.despliegaModal = true;
        this.loading = false;
        this.msjModal = "Error al actualizar correo. Correo inválido";
        this.btnEditar = false;
        this.btnGuardar = true;
      }
    }
    else {
      this.loadPerfil();
      this.despliegaModal = true;
      this.msjModal = "Error al actualizar correo. Correo vacío.";
      this.btnEditar = false;
      this.btnGuardar = true;
    }
  }

  editPerfil(response: boolean) {
    this.edit = response
  }

  onlyNumber($event) {
    let key = $event.charCode;
    if (key <= 57 && key >= 48) {
      return true;
    } else {
      return false
    }
  }

  closeModal() {
    this.despliegaModal = false;
  }

}
